// -----------------------------------------------------------------------------
// Scripts for scroll
// -----------------------------------------------------------------------------

$(document).ready(function () {

  	$('a[href^="#"]').not('.not-slide-up').on('click', function (event) {
		var targetSplit = $(this).attr('href').toString().split('#');
		
		if(targetSplit.length > 1 && targetSplit[targetSplit.length - 1] != '') {
		  	var target = $('#' + targetSplit[targetSplit.length - 1]);
			
			var headerOffset = $('.page-header').outerHeight();
			if($(window).width() < 992) {
				if($(window).height() < 600)
					headerOffset = 55;
				else
					headerOffset = 100;
			}
			if(!$('.page-header').hasClass('page-header--fixed'))
				headerOffset -= 20;

			if (target.length) {
				event.preventDefault();
				$('html, body').stop().animate({
					scrollTop: target.offset().top - headerOffset
				}, 750);
				$('.navbar-toggler').removeClass('collapsed');
				$('.navbar-collapse').removeClass('show');
			}
		} else {
			$('html, body').stop().animate({
				scrollTop: 0
			}, 750);
		}
	});

});